import React from 'react'
import { Grid } from "@mui/material";
import { UiInputGroupWr } from "../../../../../_uiComponents/common/form/UiInputComponents";
import UiInput from "../../../../_uiComponents/UiInput";
import Stack from '@mui/material/Stack';
import {
    UiButton,
} from "../../../../../_uiComponents/common/form/UiButton";
import AllocatedPoints from './AllocatedPoints';
import RewardDistributionSchedule from './RewardDistributionSchedule';
import RewardDistributionSummary from './RewardDistributionSummary';
import UiDateRangePicker from '../../../../_uiComponents/UiDateRangePicker';
import { SearchBarWr } from "../../../../../_uiComponents/common/form/UiInputComponents";
import { UiAccordian } from "../../../../../_uiComponents/common/form/UiToggleArea";
import RewardDisributionSummaryFilterForm from "./forms/RewardDistributionSummaryFilterForm"


export default function Rewards(props) {


    return (
        <>
            <Grid container spacing={2} sx={{ mt: 2, mb: 6 }}>
                <Grid item xs="12" lg="4">
                    <div className='sbm-rewards-top-box sbm-rewards-allocated-points'>
                        <h3>Total Points Budget</h3>
                        <span>2250</span>
                    </div>
                </Grid>
                <Grid item xs="12" lg="4">
                    <div className='sbm-rewards-top-box sbm-rewards-utilized-points'>
                        <h3>Total Issued Points</h3>
                        <span>1000</span>
                    </div>
                </Grid>
                <Grid item xs="12" lg="4">
                    <div className='sbm-rewards-top-box sbm-rewards-remaining-points'>
                        <h3>Total Unissued Points</h3>
                        <span>1250</span>
                    </div>
                </Grid>
            </Grid>
            <UiInputGroupWr
                title="Allocated Points"
            >
                <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid
                        item
                        xs="12"
                        lg="6"
                    >

                        <UiInput
                            type="text"
                            label="Points"
                        />


                    </Grid>
                    <Grid
                        item
                        xs="12"
                        lg="6"
                    >
                        <span className='sba-point-background'>£ 100</span>
                    </Grid>
                </Grid>
                <Grid container spacing={2} >
                    <Grid
                        item
                        xs="12"
                        lg="6"
                    >
                        <UiInput
                            label="Reason"
                            multiline={true}
                            minRows={3}
                            maxRows={5} />
                    </Grid>
                    <Grid item xs="12" lg="12" sx={{ mb: 2 }} >
                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                            <UiButton name="Clear" variant="outlined" size="small" />
                            <UiButton name="Request" variant="contained" size="small" />
                        </Stack>
                    </Grid>
                </Grid>
                <AllocatedPoints />
            </UiInputGroupWr>

            <UiInputGroupWr
                title="Reward Distribution Schedule"
            >
                <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid
                        item
                        xs="12"
                        lg="6"
                    >
                        <UiInput
                            type="text"
                            label="Distribute Rewards Every"
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} >
                    <Grid
                        item
                        xs="12"
                        lg="6"
                    >
                        <UiDateRangePicker />
                    </Grid>
                </Grid>
                <RewardDistributionSchedule />
            </UiInputGroupWr>

            <UiInputGroupWr
                title="Reward Distribution Summary"
                className="sba-reward-distribution-summary"
            >
                <Grid container spacing={2}>
                    <Grid
                        item
                        xs="12"
                        lg="12"
                    >
                        <UiAccordian>
                            <SearchBarWr>
                                <RewardDisributionSummaryFilterForm />
                            </SearchBarWr>
                        </UiAccordian>
                    </Grid>
                </Grid>
                <RewardDistributionSummary />
            </UiInputGroupWr>



        </>
    )
}
